"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var UnitPackage_1 = require("../models/UnitPackage");
var mockUnitPackage = __assign(__assign({}, UnitPackage_1.makeEmptyUnitPackage()), { description: 'mock-description' });
exports.default = mockUnitPackage;
//# sourceMappingURL=mockUnitPackage.js.map